import { useEffect, useState } from "react";
import Input from "../Input/Input";
import "./InputsInTable.scss";
import { MdDelete } from "react-icons/md";
import Reactportal from "../Reactportal/Reactportal";
import { RiErrorWarningFill } from "react-icons/ri";
import PortalFooter from "../Reactportal/PortalFooter";
import { Addition } from "../../../CommonFunction/CalculationsWithDecimalValues";

interface propsType {
  headers: string[];
  data: any;
  HandleInputChange: (evt: React.ChangeEvent<HTMLInputElement>, Id: number, key: string, i?: number, name?: String) => void;
  handleOnFocus: (evt: React.ChangeEvent<HTMLInputElement>, Id: string, RefId: number) => void;
  handleDelete: (ID: string) => void;
  title: string;
  checkDisable?: string[];
  formkey?: string;
  onErrorsChange?: (errors: any) => void;
  onSubmit?: () => void;
  footerData?: {};
  isDeleteAccess?: Boolean
}

export const InputsInTable = ({
  headers,
  data,
  HandleInputChange,
  handleOnFocus,
  handleDelete,
  title,
  checkDisable,
  formkey,
  onErrorsChange,
  onSubmit,
  footerData = {},
  isDeleteAccess = true,
}: propsType) => {
  let FooterData = { ...footerData };
  const [tableData, setTableData] = useState(data);
  const [deleteState, setDeleteState] = useState<boolean>(false);
  const [refId, setRefId] = useState("");
  const [errors, setErrors] = useState({});
  // Function to validate fields
const validateFields = (data) => {
  const currentErrors = {};

  // Create fresh errors based on current data
  Object.keys(data).forEach((key) => {
    currentErrors[key] = {};

    data[key]?.forEach((item) => {
      if (item?.isRequired && !item.value) {
        const inputId = `${key}-${item.name}`;
        currentErrors[key][item.name] = {
          error: `${item.label || item.name} is required`,
          id: inputId,
        };
      }
    });

    // Remove if no field-level errors
    if (Object.keys(currentErrors[key]).length === 0) {
      delete currentErrors[key]; // ⚠️ delete keys with no inner errors
    }
  });

  setErrors(currentErrors);
  if (onErrorsChange) {
    onErrorsChange(currentErrors);
  }
};


  const handleReferenceType = () => { };

  const HandleDeleteRef = (key) => {
    const keyCount = Object.keys(data).length;
    if (keyCount > 1) {
      setRefId(key);
      setDeleteState(true);
    }
  };

  useEffect(() => {
    validateFields(data); 
    setTableData(data);
  }, [data]);




  return (
    <>
      <div className="InputsIntableContainer">
        <table className="sales-table-main">
          <thead>
            <tr>
              {headers?.map((el: string, index) => {
                return <th key={index}>{formkey === "Purchase_Bill" && el == "Sales A/c" ? "Purchase A/c" : el}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {tableData !== undefined &&
              tableData !== null &&
              Object.keys(tableData).map((key, i) => {
                return (
                  <tr key={key}>
                    {tableData[key]?.map((item) => {
                      if (item) {
                        // console.log(item, "itemitem")
                        const inputId = `${key}-${item?.name}`; // Create unique id
                        if ("Stock_Item" === item?.name) {
                        }
                        if (item.label in FooterData && item.value !== undefined) {
                          // console.log(item, "rowidrowid105", item.label);
                          FooterData[item.label] = Addition(Number(item.value), FooterData[item.label]);
                        }
                        return (
                          <td key={item.id} className={`${item?.disabled ? "disableCol" : ""}`}>
                            {item.Input ? (
                              <Input
                                EMTQuery=""
                                checked={""}
                                InputConfig={{ ...item, rowId: key }}
                                RowId={key}
                                value={item.value === undefined ? "" : item.value}
                                id={inputId || ""} // Assign unique id to input
                                type={item.Type || item.type}
                                disabled={checkDisable?.includes(item.name) || item?.disabled}
                                handleInputChange={(evt) => {

                                  HandleInputChange(evt, item.id, key, i, item.name);
                                  handleReferenceType();
                                  validateFields(tableData);
                                }}
                                handleBlur={(e) => { }}
                                name={item.name}
                                TypeOfPortal={""}
                                modalform={true}
                                Section_Type=""
                                className=""
                                touched={false}
                                error=""
                                // error={errors[key]?.[item.name]?.error} // Display error message
                                dropdowndata={item.dropdowndata ? item.dropdowndata : ""}
                                label=""
                                max={Infinity}
                                JurnalDropdown={true}

                                transactions={false}
                                PaymentProcess=""
                                notSearchable={item.notSearchable || false}

                                onFocus={(evt) => handleOnFocus(evt, key, item.id)}
                                formkey={formkey}
                              />
                            ) : (
                              item[item]
                            )}
                          </td>
                        );
                      }
                    })}
                    {title !== "Connection Memo Updation" && title !== "Connection Memo Receive" && isDeleteAccess && (
                      <td onClick={() => HandleDeleteRef(key)}>
                        <MdDelete />
                      </td>
                    )}
                  </tr>
                );
              })}
          </tbody>
          <tfoot>
            <tr>
              {headers?.map((el: string, index) => {
                if (index == 0) {
                  return <th>{Object.keys(tableData).length}</th>;
                }
                if (el in FooterData && FooterData[el] !== undefined) {
                  return <th key={index}>{FooterData[el]}</th>;
                }
                return <th></th>;
              })}

            </tr>
          </tfoot>
        </table>
      </div>
      {deleteState && (
        <Reactportal open={deleteState} onClose={() => setDeleteState(false)} TypeOfPortal={"Confirm"}>
          <div className="warning">
            <RiErrorWarningFill className="warningIcon" />
            <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
          </div>

          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitform={() => {
              handleDelete(refId);
              setDeleteState(false);
              
            }}
            submitType={"Confirm Delete"}
            handleformclose={() => {
              setDeleteState(!deleteState);
            }}
            loadingState={false}
          />
        </Reactportal>
      )}
    </>
  );
};
